import { render, staticRenderFns } from "./AdminSidebarNav.vue?vue&type=template&id=7ed35e94&scoped=true&"
import script from "./AdminSidebarNav.vue?vue&type=script&lang=js&"
export * from "./AdminSidebarNav.vue?vue&type=script&lang=js&"
import style0 from "./AdminSidebarNav.vue?vue&type=style&index=0&id=7ed35e94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed35e94",
  null
  
)

export default component.exports